import { Component, OnInit, OnDestroy } from '@angular/core';
import { ControlPanelStore } from 'src/states/control-panel.store';
import { LoaderService } from 'src/core/layouts/loader/loader.service';
import { EnvService } from 'src/environments/environment';
import { buttonGroupEditor } from 'devexpress-dashboard/designer/form-adapter/_form-adapter-editors';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DashboardGlobalDto, DashboardParcDto, DemandeEvacuationDto, InterventionDto, ParcActifDto, ParcDetailsDto, ParcDto, ParcLimitropheDto, PermissionPrefix, PermissionType } from 'src/api/models';
import { alert } from 'devextreme/ui/dialog';
import { Dashboards } from './state/dashboard.actions';
import { DashboardStore } from './state/dashboard.store';
import { ControlPanel } from 'src/states/control-panel.actions';
import { Parcs } from '../parcs/state/parcs.actions';
import { ParcsStore } from '../parcs/state/parcs.store';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/core/layouts/components/base/base.component';
import { ControlPanelService } from 'src/states/control-panel.service';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { Router } from '@angular/router';
import { NotificationService, TypeMessage } from 'src/core/services/notification.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent extends BaseComponent implements OnInit, OnDestroy {
  dashboardEndpoint: string = '/api/dashboard'

  @Select(DashboardStore.global$)
  globalData$: Observable<DashboardGlobalDto>;

  @Select(DashboardStore.parc$)
  parcData$: Observable<DashboardParcDto>;
  Interventions: InterventionDto[] = [];
  Evacuations: DemandeEvacuationDto[] = [];

  @Select(ControlPanelStore.parcId$)
  parcId$: Observable<number>;
  parcId: number = null;

  @Select(ControlPanelStore.parc$)
  parc$: Observable<ParcDetailsDto>;

  @Select(ParcsStore.parcsActifs$)
  parcs$: Observable<ParcActifDto[]>;

  showParcsLimitrophes: boolean = false;
  showEnlevements: boolean = false;
  showInterventions: boolean = false;

  previousIW1: any = null;
  previousIW2: any = null;

  TopItems: any = [];
  SideItems: any = [];
  NumerosSpeciaux: string = null;

  dataLoaded: boolean = false;

  screen(width) {
    return (width < 1200) ? 'sm' : 'lg';
  }

  constructor(
    private router: Router,
    private notificationService: NotificationService,
    private store: Store,
    private controlPanelService: ControlPanelService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {

      super(controlPanelService, PermissionPrefix.Base);
      this.showParcsLimitrophes = false;
      this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());
      this.Subscriptions.push(this.parcId$.subscribe( pi => {
        if (this.dataLoaded) return;
        /*if (!x) {
          this.parcId = null;
          return;
        }*/
        this.parcId = pi;
        /*this.showEnlevements = true;
        this.showInterventions = true;*/

        this.store.dispatch(new Dashboards.CleanStore()).subscribe(() => {
          if(!!this.parcId) {
            this.store.dispatch(new Dashboards.GetParcData(this.parcId));
            this.showParcsLimitrophes = true;
          } else {
            this.store.dispatch(new Dashboards.GetGlobalData());
            this.store.dispatch(new Parcs.GetActifs());
          }
          this.dataLoaded = true;
        });

      }));

      this.Subscriptions.push(this.globalData$.subscribe( gd => {
        if(gd != null) {
          this.Interventions = [];
          this.Evacuations = [];
          this.showEnlevements = false;
          this.showInterventions = false;

          this.TopItems = [
            {
              value: gd?.VisitesYesterday,
              label: 'Dashboard.VisitesHier',
              type: 'counterbox',
              class: 'dashboard-box'
            },
            {
              value: gd?.VisitesToday,
              label: 'Dashboard.VisitesAujourdhui',
              type: 'counterbox',
              class: 'dashboard-box'
            },
            {
              value: gd?.VisitesLast7Days,
              label: 'Dashboard.Visites7jours',
              type: 'counterbox',
              class: 'dashboard-box'
            },
            {
              value: gd?.ConteneursLivres,
              label: 'Dashboard.ConteneursLivres',
              type: 'counterbox',
              class: 'dashboard-box'
            },
          ];

          this.SideItems = [
            {
              value: gd?.DemandesTransportEnDemande,
              label: 'Dashboard.TransportsEnDemande',
              type: 'counterbox',
              class: 'dashboard-box'
            },
            {
              value: gd?.DemandesTransportEnCours,
              label: 'Dashboard.TransportsEnCours',
              type: 'counterbox',
              class: 'dashboard-box'
            },
            {
              value: gd?.DemandesTransportLivres,
              label: 'Dashboard.TransportsLivrés',
              type: 'counterbox',
              class: 'dashboard-box'
            }
          ];
        }
      }));

      this.Subscriptions.push(this.parcData$.subscribe( pd => {
        if(pd != null) {
          if (pd && pd.NumerosSpeciaux) {
            this.NumerosSpeciaux = '<table style="min-width: 200px;">';
            this.NumerosSpeciaux += pd.NumerosSpeciaux.map( n => '<tr><td>' + n.Intitule+'</td><td>'+ n.Numero + '</td></tr>').join(' ');
            this.NumerosSpeciaux += "</table>"
          } else {
            this.NumerosSpeciaux = null;
          }

          if ( pd ) {
            this.showEnlevements = true;
            this.showInterventions = true;
            this.Interventions = pd.Interventions;
            this.Evacuations = pd.Enlevements;
          } else {
            this.Interventions = [];
            this.Evacuations = [];
          }

          let alerts = '<ul class="alertes">';
          if (pd && pd.AlertesEnCours) {
            alerts += pd.AlertesEnCours.map( a => '<li><strong>'+a.Intitule+'</strong><br/>'+a.Commentaire+'</li>').join(' ');
          }
          alerts += '</ul>';

          let docs = '<ul class="documents">';
          if (pd && pd.Documents) {
            docs += pd.Documents.map( d => '<li><a href="' + d.Lien + '" target="_blank">' + d.Titre +'</a></li>').join(' ');
          }
          docs += '</ul>';

          this.TopItems = [
            {
              label: 'Dashboard.CreateVisit',
              type: 'button',
              class: 'btn-visit',
              //route: [ '/pda', 'visite', 'identification']
              action: () => this.createVisite()
            },
            {
              label: 'Dashboard.NumerosSpeciaux',
              type: 'button',
              class: 'btn-numeros-speciaux',
              action: () => alert(this.NumerosSpeciaux, this.translate.instant('Dashboard.NumerosSpeciaux'))
            },
            {
              value: pd?.VisitesYesterday,
              label: 'Dashboard.VisitesHier',
              type: 'counterbox',
              class: 'dashboard-box'
            },
            {
              value: pd?.VisitesToday,
              label: 'Dashboard.VisitesAujourdhui',
              type: 'counterbox',
              class: 'dashboard-box'
            },
            {
              value: pd?.VisitesLast7Days,
              label: 'Dashboard.Visites7jours',
              type: 'counterbox',
              class: 'dashboard-box'
            },
            {
              value: pd?.ConteneursLivres,
              label: 'Dashboard.ConteneursLivres',
              type: 'counterbox',
              class: 'dashboard-box'
            },
          ];

          this.SideItems = [
            {
              title: "Dashboard.FlashAlertes",
              type: "content",
              content: alerts
            },
            {
              title: "Dashboard.Documents",
              type: "content",
              content: docs
            }
          ];
        }
      }));
  }

  ngOnInit() {
  }

  createVisite() {
    const allowCreateVisite =
      this.HavePermission(this.controlPanelService, PermissionPrefix.Visite, PermissionType.Ecriture) &&
      this.HavePermission(this.controlPanelService, PermissionPrefix.Visite, PermissionType.Modification);

    if (allowCreateVisite) {
      this.router.navigate(['/pda', 'visite', 'identification']);
    } else {
      this.notificationService.displayMessage(TypeMessage.error, this.translate.instant('Dashboard.Notification.CreateVisiteForbidden'));
    }
  }

  parcIcon(p: ParcDetailsDto) {
    if (p.EstEnFermetureTemporaire) return './assets/img/map-icon-orange.png';
    if (p.EstOuvert) return './assets/img/map-icon-green.png';
    return './assets/img/map-icon-red.png';
  }

  nearParcIcon(p: ParcLimitropheDto) {
    if (p.EstEnFermetureTemporaire) return './assets/img/map-icon-orange1.png';
    if (p.EstOuvert) return './assets/img/map-icon-green1.png';
    return './assets/img/map-icon-red1.png';
  }

  clickedMarker(infowindow1, infowindow2, parcId) {

    if (this.previousIW1) {
      this.previousIW1.close();
    }

    if (this.previousIW2) {
      this.previousIW2.close();
    }

    this.previousIW1 = infowindow1;
    this.previousIW2 = infowindow2;

  }

  isSmallWidth() {
    return window.innerWidth < 1200;
  }

}
